import { publicRoutes } from "@/router/index";
import { getUserPermissionTree } from "@/api/power-cable-auth/permission";

// 生成嵌套路由（子路由）

export function generateChildRouters(data) {
  const routers = [];
  for (const item of data) {
    const component = item.meta.component;
    // let componentPath
    const componentPath = (resolve) => require(["@/views/" + component + ".vue"], resolve);
    const menu = {
      path: item.meta.path,
      name: item.meta.name || item.id,
      component: componentPath,
      // redirect: item.redirect,
      isHide: item.meta.hidden,
      meta: {
        title: item.name,
        activeMenu: item.meta.activeRoute,
        identity: item.meta.identity,
        url: item.meta.path,
      },
    };
    if (item.children?.length){
      const leaf = findFirstLeafRoute(item.children)
      if (leaf) menu.redirect = leaf
    }
    if (item.children && item.children.length > 0) {
      menu.children = [...generateChildRouters(item.children)];
    }
    routers.push(menu);
  }
  return routers;
}
export function findFirstLeafRoute(routes) {
  for (const route of routes) {
    if (route.children?.length) {
      const leaf = findFirstLeafRoute(route.children)
      if (leaf) return leaf
    } else if (route.meta.path) {
      return route.meta.path
    }
  }
  return ''
}

const state = {
  routes: [],
  addRoutes: [],
  userResources: [],
  secondRoutes:[],
  menuPath: '/',
  // 是否加载动态路由
  isPermissionTreeLoaded: false,
};

const mutations = {
  // 设置动态路由
  SET_PERMISSION_TREE_LOADED(state, payload) {
    state.isPermissionTreeLoaded = payload;
  },
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = publicRoutes.concat(routes);
  },
  SET_RESOURCES: (state, resources) => {
    state.userResources = resources;
  },
  SET_MENU_PATH(state, payload) {
    state.menuPath = payload;
  },
  SET_SECOND_ROUTES:(state, routes) =>{
    state.secondRoutes = routes
  }
};

const actions = {
  generateRoutes({ commit }) {
    return new Promise((resolve) => {
      getUserPermissionTree().then((res) => {
        let result = generateChildRouters(res.data);
        commit("SET_ROUTES", result);
        commit("SET_RESOURCES", res.data);
        resolve(result);
      });
    });
  }
};
const getters = {
  getRoutes:(state) => state.addRoutes,
  getMenuType: (state) => state.menuPath,
  getSecondRoutes(state) {
    // 添加业务类型筛选器
    let tree = filterTree(
      JSON.parse(JSON.stringify(state.secondRoutes)),
      (node) => {
        if (node.isHide) {
          return false;
        } else {
          return true;
        }
      },
    );
    return tree;
  },
};

function filterTree(tree, condition) {
  // 创建一个新的空树
  const filteredTree = [];

  // 遍历原始树的每个节点
  for (const node of tree) {
    // 检查节点是否满足条件
    if (condition(node)) {
      // 如果满足条件，则将节点添加到新树中
      filteredTree.push(node);

      // 如果节点有子节点，则递归过滤子节点
      if (node.children) {
        node.children = filterTree(node.children, condition);
      }
    }
  }

  return filteredTree;
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
